import { render } from "./app_bar_and_navigation_drawer.vue?vue&type=template&id=6becda2a&scoped=true"
import script from "./app_bar_and_navigation_drawer.vue?vue&type=script&lang=js"
export * from "./app_bar_and_navigation_drawer.vue?vue&type=script&lang=js"

import "./app_bar_and_navigation_drawer.vue?vue&type=style&index=0&id=6becda2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6becda2a"]])

export default __exports__